<template>
    <div class="loading-model">
        <!-- <img :src="staticState+'static/images/loading.gif'" alt=""> -->
        <img src="../assets/images/contractPoint/pointLoading.gif">
    </div>
</template>

<script>
    import * as configs from "@/../config/config"
    export default {
        name: "Loading",
        data() {
            return {
                staticState: configs[configs.Edition].staticState,
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";
    .loading-model {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        min-height: torem(30);
        align-items: center;
        display: flex;
        z-index: 99;
        @include background_color("background-color-4");
        img {
            width:20%;
            display: block;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/compontents/pointLoading.vue